import script from "./CalendarEventForm.vue?vue&type=script&setup=true&lang=js"
export * from "./CalendarEventForm.vue?vue&type=script&setup=true&lang=js"

import "./CalendarEventForm.vue?vue&type=style&index=0&id=21585577&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21585577"]])

export default __exports__